(ns frontend.view.reports.custom.alj-2
  (:require
   [frontend.view.reports.custom.alj-2.active-deals-charts :as active-deals-charts]
   [frontend.view.reports.custom.alj-2.active-deals-per-bu-and-deal-type-table :as
    active-deals-per-bu-and-deal-type-table]
   [frontend.view.reports.custom.alj-2.active-deals-per-bu-and-stage-table :as
    active-deals-per-bu-and-stage-table]
   [frontend.view.reports.custom.alj-2.active-deals-per-deadline-to-close-bar-chart :as
    active-deals-per-deadline-to-close-bar-chart]
   [frontend.view.reports.custom.alj-2.active-deals-per-deadline-to-close-drilldown-table :as
    active-deals-per-deadline-to-close-drilldown-table]
   [frontend.view.reports.custom.alj-2.active-deals-per-deal-type-bar-chart :as
    active-deals-per-deal-type-bar-chart]
   [frontend.view.reports.custom.alj-2.active-deals-per-industry-bar-chart :as
    active-deals-per-industry-bar-chart]
   [frontend.view.reports.custom.alj-2.active-deals-per-segment-bar-chart :as
    active-deals-per-segment-bar-chart]
   [frontend.view.reports.custom.alj-2.active-deals-per-sop-stage-bar-chart :as
    active-deals-per-sop-stage-bar-chart]
   [frontend.view.reports.custom.alj-2.completed-deals-charts :as completed-deals-charts]
   [frontend.view.reports.custom.alj-2.deals-approved-by-CIC-this-year-per-bu-and-deal-type-table
    :as deals-approved-by-CIC-this-year-per-bu-and-deal-type-table]
   [frontend.view.reports.custom.alj-2.deals-approved-charts :as deals-approved]
   [frontend.view.reports.custom.alj-2.deals-approved-this-year-by-deal-type-pie-chart :as
    deals-approved-this-year-by-deal-type-pie-chart]
   [frontend.view.reports.custom.alj-2.deals-per-status-pie :as deals-per-status-pie]
   [frontend.view.reports.custom.alj-2.deals-presented-to-CIC-charts :as deals-presented-to-cic]
   [frontend.view.reports.custom.alj-2.deals-presented-to-CIC-this-year-per-bu-table :as
    deals-presented-to-CIC-this-year-per-bu-table]
   [frontend.view.reports.custom.alj-2.deals-presented-to-CIC-this-year-pie-chart :as
    deals-presented-to-CIC-this-year-pie-chart]
   [frontend.view.reports.custom.alj-2.total-deals-charts :as total-deals-charts]
   [frontend.view.reports.custom.alj-2.total-deals-per-business-unit-table :as
    total-deals-per-business-unit-table]
   [reagent.core :as r]))




(defn view
  [{:keys [state] :as args}]
  (let [reports-state (r/atom {})]
    (r/create-class
     {:reagent-render
      (fn [{:keys [state] :as args}]
        [:<>
         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [deals-per-status-pie/report args]]
          [:div
           [deals-approved/pie-chart args]
           #_[deals-approved-this-year-by-deal-type-pie-chart/report args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [total-deals-charts/total-deals args]]
          [:div
           [total-deals-charts/total-deals-by-deal-type args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [total-deals-charts/total-deals-bu-and-value args]]
          [:div
           [total-deals-charts/total-deals-bu-and-number-of-deals args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [completed-deals-charts/completed-deals-bu-and-value args]]
          [:div
           [completed-deals-charts/completed-deals-bu-and-number-of-deals args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [completed-deals-charts/completed-deals-deal-type-and-value args]]
          [:div
           [completed-deals-charts/completed-deals-deal-type-and-number-of-deals args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [active-deals-charts/active-deals-bu-ticket-size args]]
          [:div
           [active-deals-charts/active-deals-bu-number-of-deals args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [active-deals-charts/active-deals-deal-type-ticket-size args]]
          [:div
           [active-deals-charts/active-deals-deal-type-number-of-deals args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [active-deals-per-sop-stage-bar-chart/report args]]
          [:div
           [active-deals-per-deal-type-bar-chart/report args]]]


         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [active-deals-per-industry-bar-chart/report args]]
          [:div
           [active-deals-per-segment-bar-chart/report args]]]

         [:div
          {:class "grid grid-cols-10 gap-4 px-4"}
          [:div
           {:class-name "col-span-10 md:col-spal-4"}
           [active-deals-per-deadline-to-close-bar-chart/report
            (assoc args :reports-state reports-state)]]
          [:div
           {:class-name "col-span-10 md:col-spal-6"}
           [active-deals-per-deadline-to-close-drilldown-table/report
            (assoc args
              :reports-state
              reports-state)]]]


         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [deals-presented-to-cic/pie-component args]]
          [:div
           [deals-presented-to-cic/table-component args]]]

         #_[:div ---
            [:div
             [deals-presented-to-cic/table-2 args]]]

         [:div
          {:class "grid grid-cols-2 gap-4"}
          [:div
           [deals-presented-to-CIC-this-year-pie-chart/report args]]
          [:div
           [deals-presented-to-cic/table-2 args]]
          #_[:div ---
             [deals-approved-this-year-by-deal-type-pie-chart/report args]]]


         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [deals-presented-to-CIC-this-year-per-bu-table/report args]]]

         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [total-deals-per-business-unit-table/report args]]]

         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [active-deals-per-bu-and-stage-table/report args]]]


         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [active-deals-per-bu-and-deal-type-table/report args]]]

         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [deals-presented-to-CIC-this-year-per-bu-table/report args]]]

         [:div
          {:class "grid grid-cols-1 gap-4"}
          [:div
           [deals-approved-by-CIC-this-year-per-bu-and-deal-type-table/report args]]]


         [:div {:style {:height "200px"}}]])})))
